/* "As featured in" strip (snippets/c-press-strip.liquid, 14 October 2026). Loaded (deferred) only with the strip.
   Runs the row only while it is on screen (.is-on), loads every ink logo the first time the row shows, and on a device with
   a mouse loads the colour logos the first time the pointer comes over the row. Also handles strips the theme editor adds or reloads. */
(function () {
  'use strict';
  if (window.__pfLoaded) return;
  window.__pfLoaded = true;
  var D = document, W = window;
  var fine = W.matchMedia && W.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var io = W.IntersectionObserver ? new IntersectionObserver(function (E) {
    E.forEach(function (e) {
      var pf = e.target;
      pf.classList.toggle('is-on', e.isIntersecting);
      /* the first time the row shows, load all its ink logos now (the ones still to the right of the screen would otherwise
         wait for their lazy load and appear late at the edge) */
      if (e.isIntersecting && !pf.__ld) { pf.__ld = true; [].forEach.call(pf.querySelectorAll('img[loading="lazy"]'), function (i) { i.loading = 'eager'; }); }
    });
  }) : null;
  function init(pf) {
    if (!pf || pf.__pf) return;
    pf.__pf = true;
    if (io) io.observe(pf); else pf.classList.add('is-on');
    var v = pf.querySelector('.pf__view');
    if (fine && v) v.addEventListener('pointerenter', function () {
      [].forEach.call(pf.querySelectorAll('img[data-src]'), function (i) { i.src = i.getAttribute('data-src'); i.removeAttribute('data-src'); });
    }, { once: true });
  }
  function all() { [].forEach.call(D.querySelectorAll('[data-pf]'), init); }
  D.addEventListener('shopify:section:load', all);
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', all); else all();
})();
